<template>

  <div class="folders">
    <!-- <div 
      @click="nodeClicked"
      :style="{'margin-left': `${depth * 20}px`}"
      :class="[lastExpandedFolder.name===node.nome && expanded ? 'selectedFolder node' : 'node']" 
    >
      <span id="expandedFolder"
        v-if="hasChildren && expanded"
        class="type"
      >
        <v-icon :class="[ lastExpandedFolder.name===node.nome ? 'selectedFolder folderIcon' : 'folderIcon createdByRobot' ]" dark >folder_open</v-icon>
      </span>
      <span id="unexpandedFolder"
        v-else-if="hasChildren && !expanded"
        class="type"
      >
        <v-icon class="folderIcon createdByRobot"  dark>folder</v-icon>
      </span>
      <span class="nodeName" v-if="hasChildren" >{{node.nome}} </span>
    </div> -->

    <v-icon v-if="!node.file">
      {{ this.open ? 'mdi-folder-open' : 'mdi-folder' }}
    </v-icon>
    
  </div>
</template>

<script>
import DocumentosService from '@/domain/documentos/Documentos';
import LoginVue from '../../../guestArea/login/Login.vue';
export default {
  name: 'TreeBrowser',
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0,
    },
    root: Array,
    selected: Array,
    open: Array,
  },
  data() {
    return {
      // expanded: false,
      expandedFolder: '',
      globalArea: true,
      dialogRenomearArquivo: false,
      renameType: '',
      editedItem: {
        name: '',
        createdBy: '',
        dateUpdate: '',
      },
    }
  },
  methods: {
    updateBreadcrumbsNode(node) {
      this.$store.commit('addLastExpandedFolder', { name: node.nome, id: node.idPasta, parentId: node.idPai, origin: node.origin });
      node.expanded = true;
      const position = this.breadcrumbs.map(e =>  e.id).indexOf(this.lastExpandedFolder.id);
      
      if(this.breadcrumbs.length !== position + 1) {
        this.$store.commit('updateBreadcrumbs', position);
        this.handleCloseFolders(node);
      }      
    },
    selectFolder() {
      this.node.expanded = false;
      const folderName = this.node.nome;
      if(folderName) {
        this.editedItem.name = folderName.replace(/['"]+/g, '');
        // this.editedIndex = JSON.stringify(this.lastExpandedFolder.id).replace(/['"]+/g, '');
        // this.renameType = 'diretorio';
        this.dialogRenomearArquivo = true;
      }
    },
    renameFolder() {
      if(this.node.nome) {
        this.node.nome = this.editedItem.name;
      }
      
      this.dialogRenomearArquivo = false;
    },
    async nodeClicked() {
      if(this.node.idPasta !== this.lastExpandedFolder.id || !this.node.expanded || this.node.root) {
      this.node.expanded = !this.node.expanded;

      this.handleParentFolder(this.node);

      if (!this.hasChildren) {
        this.$emit('onClick', this.node);
      }else {
        if(this.expanded) {
          // this.handleBreadcrumbsPositions(this.node, true);
          this.$store.commit('resetBreadcrumbs');
          this.montaBreadCrumbs(this.node.idPasta);
          
          this.$store.commit('addLastExpandedFolder', { name: this.node.nome, id: this.node.idPasta, parentId: this.node.idPai, origin: this.node.origin });
          this.expandedFolder = this.node.nome;
          let newFileList = await this.getFiles(JSON.parse(JSON.stringify(this.node.children)));
          
          if(this.files !== newFileList && this.newFileList !== {}){
            this.$store.commit('resetFiles');
          }
          this.$store.commit('addFiles', newFileList);
          
        }else {
          if(this.node.nome === this.lastExpandedFolder.name || this.node.root && this.lastExpandedFolder.name !== '' ) {
            // this.handleBreadcrumbsPositions(this.node, false);
            if(this.node.root) {
              this.$store.commit('addLastExpandedFolder', { name: '', id: '', parentId: '', origin: '' });
              // this.handleRootFolder(this.node);
              // this.handleCloseFolders(this.node);
            }
            // else {
              // this.handleCloseFoldersNotRoot(this.node);
            // }
            
          }else {
            if(!this.node.root) {
              this.$store.commit('addLastExpandedFolder', { name: this.node.nome, id: this.node.idPasta, parentId: this.node.idPai, origin: this.node.origin });
            }
          }
          // this.handleCloseFoldersNotRoot(this.node);
          this.handleCloseFolders(this.node);
          const position = this.breadcrumbs.map(e =>  e.id).indexOf(this.lastExpandedFolder.id);
          if(this.breadcrumbs.length !== position + 1) {
            this.$store.commit('updateBreadcrumbs', position);
          }
          this.$store.commit('resetFiles');
          this.$store.commit('addFiles', []);
        }
        
      }
      }else {
        this.$store.commit('addLastExpandedFolder', { name: this.node.nome, id: this.node.idPasta, parentId: this.node.idPai, origin: this.node.origin });
      }
    },
    handleParentFolder(clickedNode, children=null) {
      if(clickedNode.idPai) {
        this.root.map(node => {
          let obj = node;

          if(children) {
            obj = children;
          }

          if( obj.idPasta === clickedNode.idPasta ){
            this.$store.commit('addLastExpandedFolder', { name: obj.nome, id: obj.idPasta, parentId: obj.idPai, origin: obj.origin });
            this.handleCloseFolders(obj);
            obj.expanded = true;
          }

          if(obj.idPai === clickedNode.idPai && obj.idPasta !== clickedNode.idPasta) {
            obj.expanded = false;
            return true;
          }
          if(obj.children) {
            obj.children.map(child => {
              this.handleParentFolder(clickedNode, child);
            });
          }
          
          return false;

        });
      }else{
        return;
      }
    },
    // handleRootFolder(clickedNode, children=null, firstLoop=true) {

      
    //     this.root.map(node => {
    //       console.log('1');
    //       let obj = node;

    //       if(children) {
    //         obj = children;
    //       }

    //       if(firstLoop) {
    //         if(obj.idPasta === clickedNode.idPasta) {
    //           obj.expanded = false;
    //           if(obj.children) {
    //             obj.children.map(child => {
    //               this.handleRootFolder(clickedNode, child, false);
    //             });
    //           }  
    //         }
    //       }else {
    //         obj.expanded = false;
    //           if(obj.children) {
    //             obj.children.map(child => {
    //               this.handleRootFolder(clickedNode, child, false);
    //             });
    //           }
    //       }
              
    //       return false;

    //     });
      
    // },
    // handleBreadcrumbsPositions( node, expanded ) {
    //   if(expanded){
    //     if(node.root) {
    //         this.$store.commit('resetBreadcrumbs');
    //         this.$store.commit('addBreadcrumbs', { text: node.nome, id: node.idPasta, parentId: 'root' });
    //         this.root.map(root => {
    //           if(root.idPasta !== node.idPasta) {
    //             root.expanded = false;
    //             this.handleRootFolder(root);
    //             return;
    //           }
    //         });
    //       }else {
    //         let findNode = true;
    //         while(findNode) {
    //           const lastPosition = this.breadcrumbs[this.breadcrumbs.length -1];
    //           if(lastPosition && node.idPai === lastPosition.id){
    //             this.$store.commit('addBreadcrumbs', { text: node.nome, id: node.idPasta, parentId: node.isPai });
    //             findNode = false;
    //           }else {
    //             this.$store.commit('removeBreadcrumbsLastPosition');
    //           }
    //         }
    //       }
    //   }else {
    //     if(node.root) {
    //       this.$store.commit('resetBreadcrumbs');
    //     }else {
    //       let findNode = true;
    //         while(findNode) {
    //           const lastPosition = this.breadcrumbs[this.breadcrumbs.length -1];

    //           if(node.idPasta === lastPosition.id){
    //             // this.$store.commit('addBreadcrumbs', { text: node.name, id: node._id, parentId: node.parent_id });
    //             findNode = false;
    //           }else {
    //             this.$store.commit('removeBreadcrumbsLastPosition');
    //             // this.$store.commit('addBreadcrumbs', { text: node.name, id: node._id, parentId: node.parent_id });
    //           }
    //     }
    //   }
    //   }
    // },
    handleCloseFolders(activeNode, children=null) {
      activeNode.children.map(node => {
        let obj = node;

          if(children) {
            obj = children;
          }

          obj.expanded = false;
          if(obj.children) {
            obj.children.map(child => {
              this.handleCloseFolders(activeNode, child);
            });
          }  


      });
    },
    // handleCloseFoldersNotRoot(activeNode, children=null) {
    //   activeNode.children.map(node => {
    //     let obj = node;

    //       if(children) {
    //         obj = children;
    //       }

    //       obj.expanded = false;
    //       if(obj.children) {
    //         obj.children.map(child => {
    //           this.handleRootFolder(activeNode, child);
    //         });
    //       }  


    //   });
    // },
     async getFiles(nodes) {
       let docs = [];
      
      nodes.map(child => {
        if(child.arquivos) {
          child.arquivos.map(file => docs.push(file));
        }else {
          return;
        }
      })
      return docs;
    },
    montaBreadCrumbs(idPasta) {
      return this.montaArvoreSelecionada(idPasta).map((pasta) => {
        this.$store.commit('addBreadcrumbs', { text: pasta.nome, id: pasta.idPasta, parentId: pasta.idPai ? pasta.idPai : "root" });
      });
    },
    montaArvoreSelecionada(idPasta, expand = false) {
      let buscaPai = false;
      let idBusca = idPasta;
      const estruturaPastas = [];
      while (!buscaPai) {
        const json = JSON.parse(JSON.stringify(this.mongoFolderReturn));
        const pastaAtual = json[0].situacao_fiscal.find((pasta) => pasta.idPasta === idBusca);
        estruturaPastas.push(pastaAtual);
        idBusca = pastaAtual.idPai;
        buscaPai = !pastaAtual.idPai;
      }
      return estruturaPastas.reverse();
    },
  },
  updated() {
    this.$nextTick(function() {});
  },
  computed: {
    hasChildren() {
      return this.node.children;
    },
    files() {
      this.$emit("resetCheckedOptions", this.node);
      return this.$store.state.files;
    },
    lastExpandedFolder() {
      return this.$store.state.lastExpandedFolder;
    },
    expanded() {
      return this.node.expanded;
    },
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    },
    mongoFolderReturn() {
      return this.$store.state.mongoFolderReturn;
    }
  },
}
</script>

<style scoped >
.folders {
    margin-top: 20px;
}
.node {
  text-align: left;
  font-size: 18px;
  margin-left: 20px;
  cursor: pointer;
  display: flex;
}
.nodeName {
  display: flex;
}
.type {
  margin-right: 10px;
}
.separator {
  display: flex;
  justify-content: space-evenly;
  max-width: 1180px;
  margin-top: 18px;
}
.application .theme--dark.v-icon, .theme--dark .v-icon {
  color:#009688;
}
.createdByRobot {
  color: #25476a!important;
}
.selectedFolder {
  /* color: #009688; */
  /* font-weight: 800; */
  color: #fff!important;
  background:  #25476a;
}

.editIcon {
  opacity: 0.2;
  transition: opacity 0.2s;
  margin-left: 3px;
}
.editIcon:hover {
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/docsFederal/TreeBrowser/TreeBrowser.vue